import React from "react";
import { TOOL_LABELS } from "../utils/triloChatConstants";

/**
 * TriloChatToolCalls
 *
 * Pills naming the backend tools MW is currently running, so a long answer
 * shows progress rather than an idle spinner.
 *
 * Props:
 * - toolCalls: Array of tool names
 */
const TriloChatToolCalls = ({ toolCalls }) => {
  if (!toolCalls.length) return null;

  return (
    <div className="trilochat__thinking">
      {toolCalls.map((name, i) => (
        <span key={i} className="trilochat__tool-pill">
          <span className="trilochat__tool-dot" />
          {TOOL_LABELS[name] || name}…
        </span>
      ))}
    </div>
  );
};

export default TriloChatToolCalls;
